// components/routes/AdminRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  console.log('AdminRoute - User:', user);
  console.log('AdminRoute - Is Admin:', user?.admin);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
      </div>
    );
  }

  if (!user?.admin) {
    console.log('AdminRoute - Redirecting to home, user is not admin');
    return <Navigate to="/" />;
  }

  return children;
};

export default AdminRoute;
